<template>
  <div
    class="border-neutral-40 bg-neutral-0 text-neutral-60 flex flex-row items-center justify-between gap-2 rounded-lg border-[0.5px] text-base"
    :class="{
      'px-0.5': size === 'sm',
      'p-1': size !== 'sm',
    }"
  >
    <button
      v-for="(item, index) in items"
      :key="item + index"
      :disabled="selectedIndex === index"
      class="flex items-center leading-normal font-semibold"
      :class="[
        {
          'border-neutral-30 text-primary-90 rounded-md border-[0.5px] bg-[#FAFAFA] shadow-md':
            selectedIndex === index,
          'text-base font-normal': size === 'lg',
          'font-medium': size === 'lg' && selectedIndex === index,
          'font-semibold': size !== 'lg' && selectedIndex === index,
          'text-sm font-semibold': size === 'md' || size === 'sm',
          'px-2 py-1': size === 'sm',
          'p-2': size === 'md',
          'p-2.5': size === 'lg',
        },
      ]"
      @click="selectItem(index)"
    >
      {{ item }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ImoButtonGroup',
  props: {
    size: {
      type: String,
      validators: value => ['sm', 'md', 'lg'].includes(value),
      default: 'md',
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedIndex: 0,
    }
  },
  methods: {
    selectItem(index) {
      this.selectedIndex = index
      this.$emit('select', index)
    },
  },
}
</script>
